module.exports = __webpack_public_path__ + "static/media/logout-active.f145815d.svg";